angular.module('rjmNg.directives').directive "adobeAnalyticsReportSuite", [
  () ->
    restrict: "E"
    templateUrl: "directive.adobeAnalyticsReportSuite.html"
    controllerAs: "view"
    bindToController: true
    scope:
      onCancelAddReportSuite: "&"
      onSaveReportSuite: "&"
      profiles: "<"
      reportSuites: "<"
    controller: [
      "stringService"
      (
        stringService
      ) ->

        view = @

        view.NUM_OF_ALLOWED_METRICS_AND_DIMENSIONS = 25
        view.REPORT_SUITE_SELECTION = 1
        view.METRIC_AND_DIMENSIONS_SELECTION = 2
        view.viewStep = view.REPORT_SUITE_SELECTION
        view.METRICS_TAB = 1
        view.DIMENSIONS_TAB = 2
        view.tabState = view.METRICS_TAB
        view.toTitleCase = stringService.toTitleCase

        view.selectedProfile = null
        view.isLoading = true
        view.metrics = []
        view.filteredMetrics = []
        view.selectedMetrics = []
        view.dimensions = []
        view.filteredDimensions = []
        view.selectedDimensions = []
        view.metricCount = 0
        view.dimensionCount = 0

        _reducer = (acc, obj) ->
          if obj.isSelected then ++acc else acc

        _filter = (values) ->
          values.filter( (val) ->
            val.isSelected
          ).map( (val) ->
            val.id
          )

        _resetState = (rsid) ->
          view.metrics = angular.copy(
            view.profiles.data.metrics[rsid]
          ).map( (metric) ->
            metric.isSelected = false
            metric
          )

          view.dimensions = angular.copy(
            view.profiles.data.dimensions[rsid]
          ).map( (dimension) ->
            dimension.isSelected = false
            dimension
          )
          view.metricCount = 0
          view.dimensionCount = 0
          view.tabState = view.METRICS_TAB

        view.renderTags = (tags) ->
          unless angular.isArray(tags)
            return ""
          return tags.map((tag) -> tag.name).join(", ")

        view.setProfile = (profile) ->
          view.isLoading = true
          view.selectedProfile = profile
          _resetState(profile.rsid)
          view.isLoading = false

        view.toggleMetric = () ->
          view.metricCount = view.metrics.reduce(_reducer, 0)

        view.toggleDimension = () ->
          view.dimensionCount = view.dimensions.reduce(_reducer, 0)

        view.saveReportSuite = () ->
          view.onSaveReportSuite(
            profile: view.selectedProfile,
            metrics: _filter(view.metrics),
            dimensions: _filter(view.dimensions)
          )

        return view
    ]
]
